

function SubmitIcon() {
  return (
    <svg style={{cursor: 'pointer', zIndex: 5}} xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path d="M7.95825 15.0001L3.20825 10.2501L4.39575 9.06258L7.95825 12.6251L15.6041 4.97925L16.7916 6.16675L7.95825 15.0001Z" fill="#5293FF"/>
    </svg>
  )
}

export default SubmitIcon;